export default "__VITE_ASSET__Dc9Pe$bJ__"